export const icons = {
  search: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="11" cy="11" r="8" />
      <path d="m21 21-4.35-4.35" />
    </svg>
  ),
  down: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="6 9 12 15 18 9" />
    </svg>
  ),
  check: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  ),
  code: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polyline points="16 18 22 12 16 6" />
      <polyline points="8 6 2 12 8 18" />
    </svg>
  ),
  feedback: '💬',
  bug: '🐛',
  feature: '💡',
  toolRequest: '🛠️',
  improvement: '✨',
  attachment: '📎',
  send: '📤',
  user: '👤',
  close: '✕',
  info: 'ℹ️',
  
  // Navigation icons
  home: '🏠',
  back: '←',
  notFound: '🔍',
  serverError: '⚠️',
  
  // Status icons
  loading: '⏳',
  success: '✅',
  error: '❌',
  warning: '⚠️',
};
